"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subtract = void 0;
const common_1 = require("@finley-technologies/common");
const subtract = ({ leftValue, rightValue }) => {
    // Return array which matches length of left value
    if (Array.isArray(leftValue) && typeof rightValue === 'number') {
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < leftValue.length; idx += 1) {
            const leftElement = leftValue[idx];
            if (typeof leftElement !== 'number') {
                return {
                    error: `Subtraction error: array inputs must contain numbers, received: [${leftValue}, ${rightValue}]`,
                };
            }
            result.push(leftElement - rightValue);
        }
        return {
            error: null,
            result,
        };
    }
    // Return array which matches length of right value
    if (typeof leftValue === 'number' && Array.isArray(rightValue)) {
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < rightValue.length; idx += 1) {
            const rightElement = rightValue[idx];
            if (typeof rightElement !== 'number') {
                return {
                    error: `Subtraction error: array inputs must contain numbers, received: [${leftValue}, ${rightValue}]`,
                };
            }
            result.push(leftValue - rightElement);
        }
        return {
            error: null,
            result,
        };
    }
    // Validate array lengths match
    if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
        if (leftValue.length !== rightValue.length) {
            return {
                error: `Subtraction error: array inputs must have the same length`,
            };
        }
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < leftValue.length; idx += 1) {
            const leftElement = leftValue[idx];
            const rightElement = rightValue[idx];
            if (typeof leftElement !== 'number' || typeof rightElement !== 'number') {
                return {
                    error: `Subtraction error: array inputs must contain numbers, received: [${leftValue}, ${rightValue}]`,
                };
            }
            result.push(leftElement - rightElement);
        }
        return {
            error: null,
            result,
        };
    }
    if (typeof leftValue === 'string' && typeof rightValue === 'string') {
        // Validate full date string format
        if (common_1.typeguards.isFullDateStr(leftValue) &&
            common_1.typeguards.isFullDateStr(rightValue)) {
            // Only available function is add days, to subtract just multiply right side by -1
            const result = (Date.parse(leftValue) - Date.parse(rightValue)) /
                (24 * 60 * 60 * 1000);
            // const result = commonDate.diffDays(leftValue, rightValue);
            return { error: null, result };
        }
        return {
            error: `Subtraction error: values provided were strings, but did not conform to the expected date format of yyyy-mm-dd | Inputs: [${leftValue}, ${rightValue}]`,
        };
    }
    if (typeof leftValue === 'string' && typeof rightValue === 'number') {
        // Validate full date string format
        if (common_1.typeguards.isFullDateStr(leftValue)) {
            // Only available function is add days, to subtract just multiply right side by -1
            const result = common_1.date.addDays(leftValue, -1 * rightValue);
            return { error: null, result };
        }
        return {
            error: `Subtraction error: left hand value provided was a string, but did not conform to the expected date format of yyyy-mm-dd | Inputs: [${leftValue}, ${rightValue}]`,
        };
    }
    if (typeof leftValue !== 'number' || typeof rightValue !== 'number') {
        return {
            error: `Subtraction error: inputs must be numbers, received: [${leftValue}, ${rightValue}]`,
        };
    }
    const result = leftValue - rightValue;
    return { error: null, result };
};
exports.subtract = subtract;
//# sourceMappingURL=subtract.js.map